var _defs, _rect, _path, _rect2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_46);}.cls-2{fill:#500064;}.cls-3,.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-3{stroke-width:2.8px;}.cls-4{stroke-width:3px;}.cls-5{fill:#fff;}\n        "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_46",
    cx: 16.07,
    cy: 33.89,
    r: 28.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb9834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f5913d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e38055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c6637d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9f3bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b37b9"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_instagram_link\u041C\u043E\u043D\u0442\u0430\u0436\u043D\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.33,
    ry: 9.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.17,47.51l-21.5.06-5.37,0a22.14,22.14,0,0,1-2.7-.08A9.36,9.36,0,0,1,.41,38.17l0-21.5V11.3A21.92,21.92,0,0,1,.54,8.61,9.33,9.33,0,0,1,4.72,2,9.48,9.48,0,0,1,9.83.42l21.5,0H36.7a24.44,24.44,0,0,1,2.7.09,9.46,9.46,0,0,1,8.22,9.36l0,21.5,0,5.37a21.92,21.92,0,0,1-.1,2.69A9,9,0,0,1,46.73,42a9.39,9.39,0,0,1-8.56,5.53Zm0,0A9.44,9.44,0,0,0,43.23,46a9.31,9.31,0,0,0,3.42-4,9.11,9.11,0,0,0,.71-2.56,21.7,21.7,0,0,0,.08-2.68l0-5.37,0-21.5a9.23,9.23,0,0,0-5.47-8.41A9,9,0,0,0,39.37.7,21.48,21.48,0,0,0,36.7.62H31.33L9.83.58A9.26,9.26,0,0,0,1.36,6.06,9.15,9.15,0,0,0,.63,8.62,21.69,21.69,0,0,0,.54,11.3v5.37l0,21.5a9.32,9.32,0,0,0,1.51,5,9.45,9.45,0,0,0,4,3.4,9,9,0,0,0,2.55.72,19.68,19.68,0,0,0,2.67.1l5.37,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.19,
    y: 8.19,
    width: 31.63,
    height: 31.63,
    rx: 7.42,
    ry: 7.42
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 24,
    cy: 24,
    r: 7.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 33.16,
    cy: 14.81,
    r: 2.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.5771ee879e672a85307ec555eca1901c.svg";
export { ForwardRef as ReactComponent };